import { ConcreteEncodable } from "./ConcreteEncodable";

import { StrategyFillLockResponseImplEncoder } from "../../encoder/StrategyFillLockResponseImplEncoder";

import * as CubiqTS from "../../index";
import { StrategyFillLockResponse } from "../StrategyFillLockResponse";

export class StrategyFillLockResponseImpl
  extends ConcreteEncodable
  implements StrategyFillLockResponse
{
  public static enType: string = "com.bcdfx.model.StrategyFillLockResponseImpl";

  /*FID=1*/
  public fillData: Array<CubiqTS.OrderFillData> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = StrategyFillLockResponseImplEncoder.Instance;
    this.setEncodableType(StrategyFillLockResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "StrategyFillLockResponseImpl[" +
      "fillData=" +
      this.fillData +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
